import React from 'react';
import { Form, Icon, Radio, Input, Tooltip, Announcement } from '@block/plug';
import cloneDeep from 'clone-deep';
import Url from './url';
import { doAction, validateItems } from '../../utils';
import DeclarationCard from './elements/declarationCard';
import declarationTemplate from './template';
import './index.scss';

let decalarationKey = '';

interface Props {
  ref: any;
}

interface State {
  declarationFamilyList: any[]; // 亲属列表
  isRegisterOrInvestCompany: number;
  hasFamilyInCompany: number;
  refs: any[];
}
class Declaration extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.dataChanged = false;
    this.formRef = React.createRef();
    this.state = {
      declarationFamilyList: [], // 亲属列表
      isRegisterOrInvestCompany: 0,
      hasFamilyInCompany: 0,
      refs: [], // 存储利益申报的ref集合
    };
  }

  dataChanged: boolean;

  formRef: React.RefObject<any>;

  async componentDidMount() {
    const data = (await doAction(Url.getInfo, {}, null)) || {};
    const { declarationFamilyList, isRegisterOrInvestCompany, hasFamilyInCompany } = data;
    let tempData = null;
    if (declarationFamilyList && declarationFamilyList.length > 0) {
      tempData = data.declarationFamilyList;
    } else if (hasFamilyInCompany === 1) {
      tempData = [{ ...declarationTemplate }];
    }
    this.setState({
      declarationFamilyList: tempData,
      isRegisterOrInvestCompany,
      hasFamilyInCompany,
    });
    this.formRef?.current?.setAllFieldsValue?.({
      ...(data || {}),
      companyName: isRegisterOrInvestCompany === 0 ? '' : data?.companyName,
    });
  }

  handleFieldValueChange = (code, value) => {
    // const ref = this.formRef.current;
    this.dataChanged = true;
    if (code === 'isRegisterOrInvestCompany') {
      this.setState({
        isRegisterOrInvestCompany: value,
      });
      if (value === 0) {
        this?.formRef?.current?.setFieldsValue?.({
          companyName: null,
        });
      }
    }
    if (code === 'hasFamilyInCompany') {
      this.setState({
        hasFamilyInCompany: value,
      });
      this.setState({
        declarationFamilyList: value === 0 ? [] : [{ ...declarationTemplate }],
      });
    }
  };

  handleAdd = () => {
    const { declarationFamilyList } = this.state;
    declarationFamilyList.push(declarationTemplate);
    this.setState({
      declarationFamilyList,
    });
    this.dataChanged = true;
  };

  handleDelete = (index) => {
    const { declarationFamilyList } = this.state;
    const tempData = cloneDeep(declarationFamilyList);

    tempData.splice(index, 1);
    this.dataChanged = true;
    decalarationKey = decalarationKey === '' ? ' ' : '';
    this.setState({ declarationFamilyList: tempData });
  };

  handleChange = (data, index) => {
    const { declarationFamilyList } = this.state;
    const tempData = declarationFamilyList.map((item, i) => {
      if (index === i) {
        item = data;
      }
      return item;
    });
    this.dataChanged = true;
    this.setState({ declarationFamilyList: tempData });
  };

  // 保存
  handleSave = async () => {
    const ref = this.formRef.current;
    const { refs } = this.state;
    if (ref?.validateFields() && validateItems(refs)) {
      const data = await doAction(Url.save, this.handleFetchFinalData());
      return data === undefined ? false : data;
    }
    return false;
  };

  // @ts-ignore 代码逻辑问题  handleFetchFinalData方法重复，请确认删除哪一个 获取最终组织数据
  handleFetchFinalData = () => {
    const formData = this.formRef.current.getFieldsValueIncludeHide();
    const { declarationFamilyList } = this.state;
    return { ...formData, declarationFamilyList };
  };

  handleFetchRef = (target) => {
    const { refs } = this.state;
    refs.push(target);
    this.setState({ refs });
  };

  render() {
    const { ref } = this.props;
    const { declarationFamilyList, isRegisterOrInvestCompany, hasFamilyInCompany } = this.state;
    return (
      <>
        <Announcement
          title={
            <span>
              为维护简单、廉洁的内外部关系，避免私下利益关系引发风险，请遵守以下要求：
              <br />
              一、主动申报以下行为&nbsp;&nbsp;1.在外兼职，从事第二职业。2.有亲属（含情侣）在本公司工作。注：以上行为入职后可通过“阳光申报平台”进行申报。
              <br />
              二、不从事以下禁止类行为&nbsp;&nbsp;1.工作时间从事外部兼职。2.为外部公司/机构提供咨询服务。3.于合作商处拥有权益或投资，合作商包括供应商、加盟商、代理商、经销商等。4.私人关系与职务关系冲突，如与亲属在同部门任职、亲属与你之间存在直接或间接汇报关系。
            </span>
          }
          showIcon
          type="warning"
        />
        <div className="declaration" ref={ref}>
          <Form
            className="declaration__form"
            ref={this.formRef}
            labelWidth="190px"
            onFieldValueChange={this.handleFieldValueChange}
          >
            <Form.Item labelWidth={0}>
              <span className="base-form__title">商业冲突</span>
            </Form.Item>
            <Form.Item
              formItemKey="isRegisterOrInvestCompany"
              label={
                <span>
                  是否在外部公司挂职
                  <Tooltip message="包括在外部公司挂职法人、董事、监事、高级管理人员、顾问等身份">
                    <Icon type="warning-circle-o" />
                  </Tooltip>
                  ：
                </span>
              }
              required
              message="不能为空"
            >
              <Radio.Group toFormItem>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              hide={isRegisterOrInvestCompany !== 1}
              formItemKey="companyName"
              label="公司名称："
              required
              message="不能为空"
            >
              <Input toFormItem maxLength={50} />
            </Form.Item>

            <Form.Item labelWidth={0}>
              <div className="base-form__dividing" />
            </Form.Item>

            <Form.Item labelWidth={0}>
              <span className="base-form__title">亲属申报</span>
            </Form.Item>
            <Form.Item formItemKey="hasFamilyInCompany" label="是否有亲属就职于本公司：" required message="不能为空">
              <Radio.Group toFormItem>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
          {!!hasFamilyInCompany &&
            declarationFamilyList.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={decalarationKey + index}>
                <DeclarationCard
                  onChange={this.handleChange}
                  onDelete={this.handleDelete}
                  data={item}
                  hideIcon={declarationFamilyList.length === 1}
                  index={index}
                  // @ts-ignore 参数问题
                  getRef={(target) => this.handleFetchRef(target, index)}
                />
                {index < declarationFamilyList.length - 1 && <div className="base-form__dividing" />}
              </React.Fragment>
            ))}
          {!!hasFamilyInCompany && (
            <span className="declaration__add" onClick={this.handleAdd}>
              <Icon type="add" />
              亲属
            </span>
          )}
        </div>
      </>
    );
  }
}

export default Declaration;
